/* Séda — JS propio. Vanilla, sin librerías. Cada init comprueba si su
   elemento existe, así el archivo sirve para todas las páginas. */
(function () {
  "use strict";

  if (window.__mtScriptsLoaded) return;
  window.__mtScriptsLoaded = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* --- Reveals al hacer scroll (un solo observer compartido) --- */
  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("mt-visible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { obs.observe(el); });

    // Red de seguridad: si algo no se ha revelado en 1,5 s (pestaña sin
    // pintar, observer que no dispara...), se muestra igualmente.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
    }, 1500);
  }

  /* --- Cifras que cuentan al entrar en pantalla --- */
  function initContadores() {
    var nums = document.querySelectorAll("[data-mt-count]");
    if (!nums.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-mt-count-final") || n.getAttribute("data-mt-count"); });
      return;
    }
    var vistos = [];
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (vistos.indexOf(entry.target) === -1) { vistos.push(entry.target); animar(entry.target); }
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { obs.observe(n); });

    // Red de seguridad: si a los 2 s algún número sigue sin tocar (pestaña
    // sin pintar, observer que no dispara), se pone el valor final directo.
    setTimeout(function () {
      nums.forEach(function (n) {
        if (vistos.indexOf(n) === -1) { vistos.push(n); ponerFinal(n); }
      });
    }, 2000);

    function fmt(el, val) {
      var suffix = el.getAttribute("data-mt-suffix") || "";
      var prefix = el.getAttribute("data-mt-prefix") || "";
      return prefix + val.toLocaleString("es-ES") + suffix;
    }
    function ponerFinal(el) {
      el.textContent = fmt(el, parseFloat(el.getAttribute("data-mt-count")) || 0);
    }
    function animar(el) {
      var target = parseFloat(el.getAttribute("data-mt-count")) || 0;
      var dur = 1400;
      var start = performance.now();
      var raf = false;
      function tick(now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(el, Math.round(target * eased));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      // si rAF no arranca en 900 ms, valor final sin animación
      setTimeout(function () {
        if (el.textContent === "0" || el.textContent.indexOf("0") === 0) ponerFinal(el);
      }, 900);
    }
  }

  /* --- FAQ acordeón --- */
  function initFaq() {
    var items = document.querySelectorAll(".mt-faq__item");
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector(".mt-faq__pregunta");
      var resp = item.querySelector(".mt-faq__respuesta");
      if (!btn || !resp) return;
      btn.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        item.classList.toggle("is-open", !open);
        btn.setAttribute("aria-expanded", String(!open));
        resp.style.maxHeight = open ? "0px" : resp.scrollHeight + "px";
      });
    });
    window.addEventListener("resize", function () {
      document.querySelectorAll(".mt-faq__item.is-open .mt-faq__respuesta").forEach(function (r) {
        r.style.maxHeight = r.scrollHeight + "px";
      });
    });
  }

  /* --- Marquesina de reseñas: duplica el contenido para bucle perfecto --- */
  function initMarquee() {
    var pistas = document.querySelectorAll(".mt-resenas__pista[data-mt-loop]");
    if (!pistas.length) return;
    pistas.forEach(function (pista) {
      if (reduce) { pista.removeAttribute("data-mt-loop"); return; }
      var clones = pista.innerHTML;
      pista.innerHTML = clones + clones;
    });
  }

  /* --- Cuenta atrás de la oferta --- */
  function initCountdown() {
    var els = document.querySelectorAll("[data-mt-countdown]");
    if (!els.length) return;
    els.forEach(function (el) {
      var out = el.querySelector("[data-mt-countdown-out]");
      var finStr = (el.getAttribute("data-fin") || "").trim().replace(" ", "T");
      var fin = new Date(finStr);
      if (!out || isNaN(fin.getTime())) return;
      var timer;
      function tick() {
        var diff = fin.getTime() - Date.now();
        if (diff <= 0) {
          out.textContent = "¡Últimas horas!";
          if (timer) clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        out.textContent = "Termina en " + (d > 0 ? d + "d " : "") + h + "h " + m + "m " + s + "s";
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* --- Comparador antes / después --- */
  function initComparador() {
    var comps = document.querySelectorAll("[data-mt-ba]");
    if (!comps.length) return;
    comps.forEach(function (comp) {
      var frame = comp.querySelector(".mt-ba__frame");
      var handle = comp.querySelector("[data-mt-ba-handle]");
      if (!frame || !handle) return;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        comp.style.setProperty("--mt-ba-pos", pct + "%");
        handle.setAttribute("aria-valuenow", Math.round(pct));
      }
      function posFromEvent(clientX) {
        var r = frame.getBoundingClientRect();
        setPos(((clientX - r.left) / r.width) * 100);
      }

      var arrastrando = false;
      frame.addEventListener("pointerdown", function (e) {
        arrastrando = true;
        frame.setPointerCapture(e.pointerId);
        posFromEvent(e.clientX);
      });
      frame.addEventListener("pointermove", function (e) {
        if (arrastrando) posFromEvent(e.clientX);
      });
      frame.addEventListener("pointerup", function () { arrastrando = false; });
      frame.addEventListener("pointercancel", function () { arrastrando = false; });

      handle.addEventListener("keydown", function (e) {
        var actual = parseFloat(comp.style.getPropertyValue("--mt-ba-pos")) || 50;
        if (e.key === "ArrowLeft") { setPos(actual - 3); e.preventDefault(); }
        else if (e.key === "ArrowRight") { setPos(actual + 3); e.preventDefault(); }
        else if (e.key === "Home") { setPos(0); e.preventDefault(); }
        else if (e.key === "End") { setPos(100); e.preventDefault(); }
      });
    });
  }

  /* --- Galería de la página de producto --- */
  function initGaleria() {
    var galeria = document.querySelector("[data-mt-galeria]");
    if (!galeria) return;
    var principal = galeria.querySelector(".mt-galeria__principal img");
    var minis = galeria.querySelectorAll(".mt-galeria__mini");
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener("click", function () {
        var full = mini.getAttribute("data-full");
        if (full) principal.src = full;
        minis.forEach(function (m) { m.classList.remove("is-active"); });
        mini.classList.add("is-active");
      });
    });
  }

  /* --- Selector de variantes de la página de producto --- */
  function initVariantes() {
    var dataEl = document.getElementById("mt-variantes-json");
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = document.querySelector('.mt-compra__form input[name="id"]');
    var boton = document.querySelector('[data-mt-submit]');
    var precioActual = document.querySelector("[data-mt-precio-actual]");
    var precioAntes = document.querySelector("[data-mt-precio-antes]");
    var seleccion = {};

    // Mapa color -> imagen (para cambiar la foto principal al elegir color)
    var colorImgs = null;
    var colorImgsEl = document.getElementById("mt-color-imgs-json");
    if (colorImgsEl) { try { colorImgs = JSON.parse(colorImgsEl.textContent); } catch (e) { colorImgs = null; } }
    var galeriaPrincipal = document.querySelector(".mt-galeria__principal img");
    var minisColor = document.querySelectorAll(".mt-galeria__mini");

    function aplicarImagenColor(valorColor) {
      if (!colorImgs || !galeriaPrincipal) return;
      var url = colorImgs[valorColor];
      if (!url) return;
      galeriaPrincipal.src = url;
      minisColor.forEach(function (m) { m.classList.remove("is-active"); });
    }

    document.querySelectorAll(".mt-opcion").forEach(function (grupo) {
      var nombre = grupo.getAttribute("data-opcion");
      var esColor = grupo.getAttribute("data-es-color") === "true";
      var activo = grupo.querySelector(".mt-opcion__valor.is-active");
      if (activo) {
        seleccion[nombre] = activo.getAttribute("data-valor");
        if (esColor) aplicarImagenColor(activo.getAttribute("data-valor"));
      }
      grupo.querySelectorAll(".mt-opcion__valor").forEach(function (val) {
        val.addEventListener("click", function () {
          grupo.querySelectorAll(".mt-opcion__valor").forEach(function (v) { v.classList.remove("is-active"); });
          val.classList.add("is-active");
          seleccion[nombre] = val.getAttribute("data-valor");
          if (esColor) aplicarImagenColor(val.getAttribute("data-valor"));
          actualizar();
        });
      });
    });

    function money(cents) {
      return (cents / 100).toLocaleString("es-ES", { style: "currency", currency: dataEl.getAttribute("data-moneda") || "EUR" });
    }

    function actualizar() {
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return seleccion["opt" + (i + 1)] === opt; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (precioActual) precioActual.textContent = money(match.price);
      if (precioAntes) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          precioAntes.textContent = money(match.compare_at_price);
          precioAntes.hidden = false;
        } else {
          precioAntes.hidden = true;
        }
      }
      if (boton) {
        if (match.available) {
          boton.disabled = false;
          boton.textContent = boton.getAttribute("data-texto") || "Añadir al carrito";
        } else {
          boton.disabled = true;
          boton.textContent = boton.getAttribute("data-agotado") || "Agotado";
        }
      }
    }
    actualizar();
  }

  function initTodo() {
    initMarquee();
    initReveals();
    initContadores();
    initFaq();
    initCountdown();
    initComparador();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTodo);
  } else {
    initTodo();
  }

  // Reinicio al editar en el personalizador de Shopify (sin duplicar la marquesina)
  document.addEventListener("shopify:section:load", function () {
    initReveals();
    initContadores();
    initFaq();
    initCountdown();
    initComparador();
    initGaleria();
    initVariantes();
  });
})();
